import { AccountsComponentsModule } from 'src/app/components/accounts/accounts.components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { OfflineComponentsModule } from 'src/app/components/general/offline/offline.components.module';

import { IonicModule } from '@ionic/angular';

import { AccountsSetupPageRoutingModule } from './accounts-setup-routing.module';

import { AccountsSetupPage } from './accounts-setup.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    OfflineComponentsModule,
    IonicModule,
    AccountsComponentsModule,
    AccountsSetupPageRoutingModule
  ],
  declarations: [
    AccountsSetupPage
  ],
  // entryComponents: []
})
export class AccountsSetupPageModule {}
